import { Component } from '@angular/core';

@Component({
  selector: 'app-subscriptiondetail',
  templateUrl: './subscriptiondetail.component.html',
  styleUrls: ['./subscriptiondetail.component.scss']
})
export class SubscriptiondetailComponent {

}
